import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import './Contact.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Takk for at du kontakter oss! Vi svarer deg snart.');
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="page-container contact-page">
            <Navbar />

            <section className="contact-hero">
                <div className="container">
                    <div className="contact-hero-content">
                        <span className="section-badge">KONTAKT</span>
                        <h1 className="contact-title">
                            Vi er alltid her for å <span className="gradient-text">hjelpe deg</span>
                        </h1>
                        <p className="contact-subtitle">
                            Har du spørsmål eller tilbakemeldinger? Vi vil gjerne høre fra deg.
                        </p>
                    </div>
                </div>
            </section>

            <section className="contact-content">
                <div className="container">
                    <div className="contact-grid">
                        <div className="contact-info">
                            <h2>Kontaktinformasjon</h2>
                            <p className="info-subtitle">Fyll ut skjemaet, og teamet vårt vil kontakte deg innen 24 timer.</p>

                            <div className="contact-cards">
                                <div className="contact-card">
                                    <div className="contact-icon">📧</div>
                                    <h3>Email</h3>
                                    <p>hello@talktokrishna.ai</p>
                                </div>

                                <div className="contact-card">
                                    <div className="contact-icon">💬</div>
                                    <h3>Live chat</h3>
                                    <p>Tilgjengelig 24/7</p>
                                </div>

                                <div className="contact-card">
                                    <div className="contact-icon">🌐</div>
                                    <h3>Sosiale medier</h3>
                                    <div className="social-links">
                                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
                                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
                                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
                                    </div>
                                </div>
                            </div>

                            <div className="faq-section">
                                <h3>Ofte stilte spørsmål</h3>
                                <div className="faq-item">
                                    <strong>Hvordan fungerer AI?</strong>
                                    <p>Vår AI bruker RAG-teknologi til å søke i over 700 autentiske vers fra Bhagavad Gita.</p>
                                </div>
                                <div className="faq-item">
                                    <strong>Er det gratis?</strong>
                                    <p>Ja! Grunnleggende bruk av "Snakk med Krishna" er gratis for alle brukere.</p>
                                </div>
                                <div className="faq-item">
                                    <strong>Hvilke språk støttes?</strong>
                                    <p>For øyeblikket støtter vi norsk og engelsk.</p>
                                </div>
                            </div>
                        </div>

                        <div className="contact-form-wrapper">
                            <form onSubmit={handleSubmit} className="contact-form">
                                <h2>Send melding</h2>

                                <div className="form-group">
                                    <label>Navnet ditt</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Arjuna"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>E-postadresse</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="you@example.com"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Emne</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        placeholder="Hva gjelder meldingen din?"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Melding</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Beskriv spørsmålet eller kommentaren din mer detaljert..."
                                        rows="5"
                                        required
                                    ></textarea>
                                </div>

                                <button type="submit" className="btn-premium-primary btn-large">
                                    <span className="btn-icon">📨</span>
                                    Send
                                    <span className="btn-arrow">→</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
